import React, { FC } from 'react';
import { PageBreakWrapper } from './PageBreak.styled';
import { ReactComponent as PageBreakIcon } from 'assets/images/page-break-icon.svg';
import styles from './PageBreak.module.css';

interface Props {
  pageHeight: number;
  pageBreakNumber: number;
}

const PageBreak: FC<Props> = ({ pageBreakNumber, pageHeight }) => {
  const pageBreakHeight = pageHeight * pageBreakNumber;

  return (
    <PageBreakWrapper top={pageBreakHeight}>
      <PageBreakIcon className={styles.pageBreakIcon} />
      <div className={styles.pageBreakText}>PDF page break</div>
    </PageBreakWrapper>
  );
};

export default PageBreak;
